import {axiosRequest} from "../../api";
import {API_PATH} from "../../../constants";

export const DraftPrescriptionMedicationItemService = {
  getDraftPrescriptionMedicationItemList(params: any){ return axiosRequest('GET', API_PATH.DRAFT_PRESCRIPTION_MEDICATION_ITEM.LIST(params)) },
  getDraftPrescriptionMedicationItem(data: any){ return axiosRequest('POST', API_PATH.DRAFT_PRESCRIPTION_MEDICATION_ITEM.INFO, data) },
  addDraftPrescriptionMedicationItem(data: any){ return axiosRequest('POST', API_PATH.DRAFT_PRESCRIPTION_MEDICATION_ITEM.ADD, data) },
  deleteDraftPrescriptionMedicationItem(data: any){ return axiosRequest('POST', API_PATH.DRAFT_PRESCRIPTION_MEDICATION_ITEM.DELETE, data) },
}